"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateForm = void 0;
//Bootleg error management
function validateForm(errors, formData, setErrors) {
    if (formData?.text === undefined && formData?.url === undefined) {
        return true;
    }
    if (formData?.text === '' && formData?.url === '') {
        setErrors({
            text: '',
            url: '',
        });
        return true;
    }
    const errorsCopy = { ...errors };
    let isValid = true;
    // Validate text input
    if (!formData?.text) {
        errorsCopy.text = 'Text is required';
        isValid = false;
    }
    else {
        errorsCopy.text = '';
    }
    // Validate URL input
    if (!formData?.url) {
        errorsCopy.url = 'URL is required';
        isValid = false;
    }
    else {
        errorsCopy.url = '';
    }
    setErrors(errorsCopy);
    return isValid;
}
exports.validateForm = validateForm;
exports.default = validateForm;
